// LoginPage.jsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Logo  from '../../public/assets/images/logo1.png';
import { useEffect } from "react";

function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/add-property"); // redirect to protected page if already logged in
    }
  }, [navigate]);

  const handleLogin = async () => {
    try {
      const res = await fetch("https://investorrise-gxm0.onrender.com/api/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (data.success) {
        localStorage.setItem("token", data.token);
        navigate("/add-property"); // or /delete-property
      } else {
        alert("Login failed");
      }
    } catch (err) {
      console.error("Login error:", err);
    }
  };

  return (
    // <div>
      
    //   <input placeholder="Email" onChange={(e) => setEmail(e.target.value)} />
    //   <input type="password" placeholder="Password" onChange={(e) => setPassword(e.target.value)} />
    //   <button onClick={handleLogin}>Login</button>
    // </div>

<div className="pt-32 pb-20 bg-gray-800">
 <div className="max-w-2xl mx-auto p-4 shadow-lg shadow-teal-500 rounded-lg mt-6 bg-slate-900 text-white text-base scale-90">
  <div className="flex items-center mb-4">
    <img
      src={Logo}
      alt="Property Icon"
      className="w-14 h-14 mr-3 rounded-full"
    />
    <h1 className="text-2xl font-bold">Admin Login</h1>
  </div>
  <div className="space-y-6">
   

    {/* 2-Column Fields */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
     
            <input
              placeholder="Email" onChange={(e) => setEmail(e.target.value)} 
              className="w-full text-slate-900 p-2 rounded border text-base"
              required
            />
        
         <input
              type="password" placeholder="Password" onChange={(e) => setPassword(e.target.value)} 
              className="w-full text-slate-900 p-2 rounded border text-base"
              required
            />
        
      
    </div>

    {/* Submit Button */}
    <div className="text-center">
    
      <button onClick={handleLogin} type="submit" className="relative overflow-hidden py-2 px-4 mt-4 text-white font-semibold bg-teal-500 shadow-xl text-base group">
      <span className="absolute inset-0 bg-gradient-to-r from-slate-900 to-slate-900 group-hover:from-slate-900 group-hover:to-slate-900 animate-slide-bg transition-all duration-500 ease-in-out"></span>
      <span className="relative z-10">Submit</span>
    </button>
    </div>
  </div>
</div>

{/* <br/><br/> */}

    </div>












  );
}

export default LoginPage;
